import React from "react";
import { node, string } from "prop-types";

const WithBackground = ({ children, img = undefined, textColor = "#fff" }) => {
  const withBackgroundStyle = {
    backgroundImage: `url(${img})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    minHeight: "1000px",
    color: textColor,
  };

  return <div style={withBackgroundStyle}>{children}</div>;
};

WithBackground.propTypes = {
  children: node.isRequired,
  img: string,
  textColor: string,
};

export default WithBackground;
